/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMixedSaleDto } from '../models/CreateMixedSaleDto';
import type { SaleFulfillmentDetailResponseDto } from '../models/SaleFulfillmentDetailResponseDto';
import type { SalesOrder } from '../models/SalesOrder';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalesOrdersMixedBranchFulfillmentService {
    /**
     * Confirm a sale that may include items from other branches/warehouse
     * Local items are sold immediately; remote items each generate an auto SOL and are held until the whole sale completes (see mixed-branch-sale-fulfillment-spec.md).
     * @param requestBody
     * @returns SalesOrder Mixed-branch sale confirmed
     * @throws ApiError
     */
    public static saleFulfillmentControllerConfirmMixedSale(
        requestBody: CreateMixedSaleDto,
    ): CancelablePromise<SalesOrder> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sales-orders/mixed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - validation errors`,
            },
        });
    }
    /**
     * Confirm mixed-branch sale fulfillment is already COMPLETED (idempotent)
     * Logistics auto-close to COMPLETED on last remote receive. This endpoint only succeeds when fulfillment_status is already COMPLETED; it does not perform finalize work.
     * @param id
     * @returns SalesOrder Fulfillment already COMPLETED (idempotent confirm)
     * @throws ApiError
     */
    public static saleFulfillmentControllerFinalizeFulfillment(
        id: number,
    ): CancelablePromise<SalesOrder> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sales-orders/{id}/finalize-fulfillment',
            path: {
                'id': id,
            },
            errors: {
                400: `Fulfillment is not COMPLETED yet (or was cancelled/failed)`,
                404: `Order not found`,
            },
        });
    }
    /**
     * Fulfillment group detail for a mixed-branch sale
     * Returns one entry per remote source location involved in the sale, with its SOL/TRL linkage and status.
     * @param id
     * @returns SaleFulfillmentDetailResponseDto Fulfillment groups
     * @throws ApiError
     */
    public static saleFulfillmentControllerGetFulfillmentDetail(
        id: number,
    ): CancelablePromise<SaleFulfillmentDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-orders/{id}/fulfillment',
            path: {
                'id': id,
            },
            errors: {
                404: `Order not found`,
            },
        });
    }
}
